import {NgModule} from '@angular/core'
import {PromotionalBannerSectionComponent} from './promotional-banner-section.component'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {TranslocoModule} from '@ngneat/transloco'
import {ButtonModule} from '../../../../craft/button/button.module'
import {DirectivesModule} from '../../../directives/directives.module'

@NgModule({
  declarations: [PromotionalBannerSectionComponent],
  imports: [DirectivesModule, CommonModule, TranslocoModule, ButtonModule, NgOptimizedImage],
  exports: [PromotionalBannerSectionComponent],
})
export class PromotionalBannerSectionModule {}
